// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Icons
import InfoIcon from "@material-ui/icons/Info";
// Translations 
import { withTranslation } from "react-i18next";

class NotFound extends Component {
    
    render() {
        return (
            <div className="man-pageF">
                <span>{"4 0 4"}</span>
                <span>Page not found.</span>
                <InfoIcon />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
  )(NotFound);

export default withTranslation("common")(withRouter(connect_));